const TRANSACTIONAL = "TRANSACTIONAL";
const INVENTORY = "INVENTORY";

export { TRANSACTIONAL, INVENTORY };
